import { render, staticRenderFns } from "./MenuIcon.vue?vue&type=template&id=6300e093&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6300e093')) {
      api.createRecord('6300e093', component.options)
    } else {
      api.reload('6300e093', component.options)
    }
    module.hot.accept("./MenuIcon.vue?vue&type=template&id=6300e093&", function () {
      api.rerender('6300e093', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Svg/MenuIcon.vue"
export default component.exports